import { ALERT, NEW_REQUESTS, ONGOING_REQUESTS, CONCLUDED_REQUESTS } from '../constants/actionTypes'
import * as api from '../api'

const getRequests = async (status, dispatch, setLoading, type) => {
    try {
        const { data } = await api.getProjectsOther(status)

        dispatch({ type, payload: data })
        setLoading(false)
    } catch (error) {
        setLoading(false)
        if(error.response) dispatch({ type: ALERT, payload: { severity: 'error', message: error.response.data.message, duration: 5000, display: true }})
        else dispatch({ type: ALERT, payload: { severity: 'error', message: 'An unexpected error occurred', duration: 5000, display: true }})
    }
}

export const getNewRequests = (status, setLoading) => async (dispatch) => {
    getRequests(status, dispatch, setLoading, NEW_REQUESTS)
}

export const getOngoingRequests = (status, setLoading) => async (dispatch) => {
    getRequests(status, dispatch, setLoading, ONGOING_REQUESTS)
}

export const getConcludedRequests = (status, setLoading) => async (dispatch) => {
    getRequests(status, dispatch, setLoading, CONCLUDED_REQUESTS)
}